// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'


import logo from '@/assets/img/logo.png'
import logo2 from '@/assets/img/logo2.png'

import "@/assets/bootstrap-3.3.7/js/bootstrap";
import $ from "jquery";

Vue.config.productionTip = false
Vue.prototype.image_url_prefix = "http://image.meshnb.com/";

let domain = document.domain
let name = "百利同舟"
let icp = "辽ICP备18014144号-1"
Vue.prototype.$logo = logo
if(domain.indexOf('apmesh')>=0)
{
	name = '迈旭丝网'
	icp = "冀ICP备2022024265号-1"
	Vue.prototype.$logo = logo2
}
Vue.prototype.$website_name = name
Vue.prototype.$icp = icp

window.title = name

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
